import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Play, X } from 'lucide-react';
interface WelcomeScreenProps {
  onStart: () => void;
}
export function WelcomeScreen({
  onStart
}: WelcomeScreenProps) {
  const [showImpressum, setShowImpressum] = useState(false);
  return <div className="min-h-screen w-full bg-gradient-to-br from-gray-50 to-white flex flex-col items-center justify-center px-8" data-id="element-895">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-2xl w-full space-y-12 text-center" data-id="element-896">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center" data-id="element-897">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eoQSndGhtP8GhadGkJPgap/Logo.png" alt="INTIGOO! Logo" className="h-24 w-auto" data-id="element-898" />
        </motion.div>

        {/* Demo Start Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-899">
          <button onClick={onStart} className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-xl font-semibold text-lg transition-all shadow-lg hover:shadow-xl transform hover:scale-105" data-id="element-900">
            <Play className="w-5 h-5" strokeWidth={2} data-id="element-901" />
            Demo starten
          </button>
        </motion.div>

        {/* Legal Information */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="pt-12 space-y-4 text-sm text-gray-600" data-id="element-902">
          <div className="space-y-2" data-id="element-903">
            <p className="font-semibold text-gray-900" data-id="element-904">INTIGOO! GmbH</p>
            <p data-id="element-905">Qualitätskontroll- und Prüfsystem</p>
          </div>

          <div className="pt-4 border-t border-gray-200 space-y-2" data-id="element-906">
            <p data-id="element-907">
              © {new Date().getFullYear()} INTIGOO! GmbH. Alle Rechte
              vorbehalten.
            </p>
            <div className="flex items-center justify-center gap-4 text-xs" data-id="element-908">
              <button onClick={() => setShowImpressum(true)} className="hover:text-gray-900 transition-colors" data-id="element-909">
                Impressum
              </button>
            </div>
          </div>

          <div className="pt-4 text-xs text-gray-500" data-id="element-910"></div>
        </motion.div>
      </motion.div>

      {/* Impressum Modal */}
      <AnimatePresence data-id="element-911">
        {showImpressum && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowImpressum(false)} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50" data-id="element-912" />

            {/* Modal */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-913">
              <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" data-id="element-914">
                {/* Header */}
                <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-915">
                  <h2 className="text-2xl font-bold text-gray-900" data-id="element-916">
                    Impressum
                  </h2>
                  <button onClick={() => setShowImpressum(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-917">
                    <X className="w-5 h-5 text-gray-600" data-id="element-918" />
                  </button>
                </div>

                {/* Content */}
                <div className="px-6 py-6 space-y-6 text-gray-700" data-id="element-919">
                  {/* Company Info */}
                  <section data-id="element-920">
                    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-921">
                      Angaben gemäß § 5 TMG
                    </h3>
                    <p className="font-medium" data-id="element-922">INTIGOO! GmbH</p>
                    <p data-id="element-923">Werner-von-Siemens-Straße 33</p>
                    <p data-id="element-924">49124 Georgsmarienhütte</p>
                  </section>

                  {/* Registration */}
                  <section data-id="element-925">
                    <p data-id="element-926">
                      <span className="font-semibold" data-id="element-927">Handelsregister:</span>{' '}
                      HRB 217224
                    </p>
                    <p data-id="element-928">
                      <span className="font-semibold" data-id="element-929">Registergericht:</span>{' '}
                      Amtsgericht Osnabrück
                    </p>
                  </section>

                  {/* Representatives */}
                  <section data-id="element-930">
                    <p className="font-semibold mb-1" data-id="element-931">Vertreten durch:</p>
                    <p data-id="element-932">Fabian Kleine Huxel</p>
                    <p data-id="element-933">Felix Höfelmeyer</p>
                  </section>

                  {/* Contact */}
                  <section data-id="element-934">
                    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-935">
                      Kontakt
                    </h3>
                    <p data-id="element-936">
                      <span className="font-semibold" data-id="element-937">Telefon:</span> +49 5401
                      1689580
                    </p>
                    <p data-id="element-938">
                      <span className="font-semibold" data-id="element-939">E-Mail:</span>{' '}
                      <a href="mailto:info@intigoo.de" className="text-green-600 hover:text-green-700" data-id="element-940">
                        info@intigoo.de
                      </a>
                    </p>
                  </section>

                  {/* Tax ID */}
                  <section data-id="element-941">
                    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-942">
                      Umsatzsteuer-ID
                    </h3>
                    <p data-id="element-943">
                      Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                      Umsatzsteuergesetz:
                    </p>
                    <p className="font-medium" data-id="element-944">DE 349819653</p>
                  </section>

                  {/* EU Dispute Resolution */}
                  <section data-id="element-945">
                    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-946">
                      EU-Streitschlichtung
                    </h3>
                    <p data-id="element-947">
                      Die Europäische Kommission stellt eine Plattform zur
                      Online-Streitbeilegung (OS) bereit:{' '}
                      <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-700 underline" data-id="element-948">
                        https://ec.europa.eu/consumers/odr/
                      </a>
                      .
                    </p>
                    <p className="mt-2" data-id="element-949">
                      Unsere E-Mail-Adresse finden Sie oben im Impressum.
                    </p>
                  </section>

                  {/* Consumer Dispute Resolution */}
                  <section data-id="element-950">
                    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-951">
                      Verbraucherstreitbeilegung / Universalschlichtungsstelle
                    </h3>
                    <p data-id="element-952">
                      Wir sind nicht bereit oder verpflichtet, an
                      Streitbeilegungsverfahren vor einer
                      Verbraucherschlichtungsstelle teilzunehmen.
                    </p>
                  </section>
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}